import { useEffect, useState } from "react";
import { localYmd } from '../../utils/dateOnly';
import axiosInstance from "../../services/axiosInstance";
import { useNavigate } from "react-router-dom";
import { useBreadcrumbs } from "../../contexts/BreadcrumbContext";

const InvoiceHistory = ({ customerId }) => {
    const [invoices, setInvoices] = useState([]);
    const navigate = useNavigate();
    const { push, beginDrilldown } = useBreadcrumbs();

    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const response = await axiosInstance.get(`/api/invoices/history-for-customer/${customerId}`);
                setInvoices(response.data);
            } catch (error) {
                console.error("Failed to load invoices", error);
            }
        };

        fetchInvoices();
    }, [customerId]);

    const handleRowClick = (invoice) => {
        beginDrilldown();
        navigate(`/invoices`, {
            state: {
                invId: invoice.id, // Pass the selected invoice ID
                customerId: invoice.customer // Pass the customer ID
            },
        });
        push({
            label: `Customer: ${invoice.customer_name}`,
            path: `/customers/${customerId}`,
        });
        push({
            label: `Invoices`,
            path: '/invoices',
        });
        push({
            label: `Invoice: ${invoice.invoice_number}`,
            path: '/invoices',
            state: { invId: invoice.id }
        });
    };
d:

    return (
        <div className="p-4 rounded-lg shadow">
            <h3 className="text-lg font-semibold">Invoice History</h3>
            {invoices.length === 0 ? (
                <p>No invoices found.</p>
            ) : (
                <ul>
                    {invoices.map((invoice) => (
                        <li key={invoice.id} className="border-b p-2" onClick ={() => {handleRowClick(invoice)}} style={{cursor:'pointer' }}>
                        {localYmd(new Date(invoice.date))} ({invoice.invoice_number}) Rs. {invoice.net_price} - {invoice.status}
                    </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default InvoiceHistory;
